import { render, staticRenderFns } from "./saveZMAllocation.vue?vue&type=template&id=1b6671c4"
import script from "./saveZMAllocation.vue?vue&type=script&lang=js"
export * from "./saveZMAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports